import React from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Helper',
  },
  {
    path: 'List',
    breadcrumbName: 'List',
  },
];

const List = () => {
  return (
    <>

      <PageHeader title="List" breadcrumb={{ routes }} subTitle="List-inline" style={{ padding: 10 }} />

      <div className="MF_area">
        <ul className="list_inline">
          <li>1</li>
          <li>2</li>
          <li>3</li>
        </ul>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<ul class="list_inline">
    <li>1</li>
    <li>2</li>
    <li>3</li>
</ul>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>


      <PageHeader title="List" breadcrumb={{ routes }} subTitle="List-style" style={{ padding: 10 }} />

      <div className="MF_area">
        <ul className="list_s_disc">
          <li>1</li>
          <li>2</li>
          <li>3</li>
        </ul>
        <ul className="list_s_square">
          <li>1</li>
          <li>2</li>
          <li>3</li>
        </ul>
        <ul className="list_s_disc_sm">
          <li>1</li>
          <li>2</li>
          <li>3</li>
        </ul>
        <ul className="list_s_check">
          <li>1</li>
          <li>2</li>
          <li>3</li>
        </ul>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<ul class="list_s_disc">
    <li>1</li>
    <li>2</li>
    <li>3</li>
</ul>
<div class="clearfix_dash"></div>
<ul class="list_s_square">
    <li>1</li>
    <li>2</li>
    <li>3</li>
</ul>
<div class="clearfix_dash"></div>
<ul class="list_s_disc_sm">
    <li>1</li>
    <li>2</li>
    <li>3</li>
</ul>
<div class="clearfix_dash"></div>
<ul class="list_s_check">
    <li>1</li>
    <li>2</li>
    <li>3</li>
</ul>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>





      <PageHeader title="List" breadcrumb={{ routes }} subTitle="List-style-value" style={{ padding: 10 }} />

      <div className="MF_area">
        <ul>
          <li>.list_s_{`{value}`}</li>
        </ul>
        <ul>
          <li>disc</li>
          <li>disc_sm</li>
          <li>circle</li>
          <li>square</li>
          <li>decimal</li>
          <li>check</li>
        </ul>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<ul>
  <li>.list_s_{value}</li>
</ul>
<ul>
  <li>disc</li>
  <li>disc_sm</li>
  <li>circle</li>
  <li>square</li>
  <li>decimal</li>
  <li>check</li>
</ul>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>
    </>
  );
}

export default List;
